import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { c, glassSurface } from "../../classroomColors";
import { firstName, roomMark } from "./roomPlan";

/**
 * The open rooms along the bottom of the canvas (wireframe 265:30): the
 * class, then each room with who is in it. The one on screen is lifted; any
 * other is a click away. The teacher's alone — nobody else moves between
 * rooms.
 */
const RoomStrip = ({ rooms, viewRoomId, onJoin }) => (
  <Flex
    position="absolute"
    bottom="20px"
    left="50%"
    transform="translateX(-50%)"
    maxW="min(820px, calc(100vw - 460px))"
    zIndex={18}
    gap="8px"
    p="6px"
    borderRadius="18px"
    overflowX="auto"
    data-own-scroll
    data-no-pan
    sx={{ scrollbarWidth: "none", "&::-webkit-scrollbar": { display: "none" } }}
    {...glassSurface}
  >
    <Card
      mark={c.textSub}
      name="The class"
      people={null}
      isHere={!viewRoomId}
      onClick={() => onJoin(null)}
    />
    {rooms.map((room, i) => (
      <Card
        key={room.id}
        mark={roomMark(i)}
        name={room.name}
        people={room.members}
        isHere={viewRoomId === room.id}
        onClick={() => onJoin(room.id)}
      />
    ))}
  </Flex>
);

const Card = ({ mark, name, people, isHere, onClick }) => (
  <Box
    as="button"
    type="button"
    onClick={onClick}
    aria-pressed={isHere}
    aria-label={isHere ? `${name}, on screen` : `Go to ${name}`}
    flexShrink={0}
    minW="132px"
    maxW="190px"
    textAlign="left"
    px="11px"
    py="8px"
    borderRadius="13px"
    bg={isHere ? c.solidBg : c.glassEdge}
    color={isHere ? c.solidText : c.text}
    border="1px solid"
    borderColor={isHere ? c.solidBg : c.borderSoft}
    transition="background 0.15s, transform 0.15s"
    _hover={isHere ? {} : { bg: c.surface, transform: "translateY(-1px)" }}
  >
    <Flex align="center" gap="7px">
      <Box boxSize="7px" borderRadius="full" bg={mark} flexShrink={0} />
      <Text fontSize="12.5px" fontWeight="500" noOfLines={1}>{name}</Text>
      {people && (
        <Text fontSize="11px" opacity={0.6} ml="auto" pl="6px" sx={{ fontVariantNumeric: "tabular-nums" }}>
          {people.length}
        </Text>
      )}
    </Flex>
    <Text fontSize="11px" opacity={0.7} mt="2px" noOfLines={1}>
      {people == null
        ? "Everyone else"
        : people.length
        ? people.map((m) => firstName(m.name)).join(", ")
        : "Nobody yet"}
    </Text>
  </Box>
);

export default RoomStrip;
